module.exports = __webpack_public_path__ + "static/media/web3.cf9bff9e.png";